import { createAction } from "redux-actions";

// Get phases
export const REQUESTED_PHASES = "REQUESTED_PHASES";
export const RECEIVED_PHASES = "RECEIVED_PHASES";

export const requestPhases = createAction(REQUESTED_PHASES);
export const receivePhases = createAction(RECEIVED_PHASES, (phases) => ({
  phases,
}));

// Create phase
export const REQUESTED_CREATE_PHASE = "REQUESTED_CREATE_PHASE";
export const RECEIVED_CREATE_PHASE = "RECEIVED_CREATE_PHASE";

export const requestCreatePhase = createAction(REQUESTED_CREATE_PHASE);
export const receiveCreatePhase = createAction(
  RECEIVED_CREATE_PHASE,
  (phase) => ({
    phase,
  })
);

// Update phase
export const REQUESTED_UPDATE_PHASE = "REQUESTED_UPDATE_PHASE";
export const RECEIVED_UPDATE_PHASE = "RECEIVED_UPDATE_PHASE";

export const requestUpdatePhase = createAction(REQUESTED_UPDATE_PHASE);
export const receiveUpdatePhase = createAction(
  RECEIVED_UPDATE_PHASE,
  (phase) => ({
    phase,
  })
);

// Delete phase
export const REQUESTED_DELETE_PHASE = "REQUESTED_DELETE_PHASE";
export const RECEIVED_DELETE_PHASE = "RECEIVED_DELETE_PHASE";

export const requestDeletePhase = createAction(REQUESTED_DELETE_PHASE);
export const receiveDeletePhase = createAction(
  RECEIVED_DELETE_PHASE,
  (phase) => ({
    phase,
  })
);

// Delete Version Phase by Phase
export const REQUESTED_DELETE_VERSION_PHASE = "REQUESTED_DELETE_VERSION_PHASE";
export const RECEIVED_DELETE_VERSION_PHASE = "RECEIVED_DELETE_VERSION_PHASE";

export const requestDeleteVersionPhase = createAction(
  REQUESTED_DELETE_VERSION_PHASE
);
export const receiveDeleteVersionPhase = createAction(
  RECEIVED_DELETE_VERSION_PHASE,
  (phase) => ({
    phase,
  })
);
